export default function SidebarLogo() {
  return (
    <div className="sidebar-logo">
      <div>
        <a href="index.html" className="logo logo-normal">
          <img src="assets/img/logo.svg" alt="Logo" />
        </a>

        <a href="index.html" className="logo-small">
          <img src="assets/img/logo-small.svg" alt="Logo" />
        </a>

        <a href="index.html" className="dark-logo">
          <img src="assets/img/logo-white.svg" alt="Logo" />
        </a>
      </div>

      <button className="sidenav-toggle-btn btn border-0 p-0 active" id="toggle_btn">
        <i className="ti ti-arrow-left text-body"></i>
      </button>

      <button className="sidebar-close">
        <i className="ti ti-x align-middle"></i>
      </button>
    </div>
  );
}
